/**
 * IconsRow - Owner Analytics header icon buttons
 *
 * Renders the Guide (info) button only. Used as headerTopRightSlot in OwnerPageChrome.
 * Insights feature removed; no Insights icon or modal.
 */
import React from 'react';

export default function IconsRow({ onOpenGuide }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'flex-end', flexShrink: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '4px', border: '1px solid #e5e7eb', backgroundColor: '#ffffff', cursor: 'pointer', color: '#6b7280', position: 'relative', transition: 'all 0.15s ease', padding: '0' }} onClick={onOpenGuide} title="Analytics Guide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4M12 8h.01" />
        </svg>
      </div>
    </div>
  );
}
